document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper('.featured-blog__wrapper', {
    slidesPerView: 3,
    spaceBetween: 50,
    slidesPerGroup: 1,
    loop: false,
    loopFillGroupWithBlank: true,
    pagination: {
      el: '.recipe.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.recipe.swiper-button-next',
      prevEl: '.recipe.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
      },
      544: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      }
    }
  });
});